import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import FavorecidoAPi from "../../../../services/favorecidoApi";
// import MuralApi from "../../../../services/muralApi";
import TitleFlex from "../defaultComponents/titleFlex";
// import { goToVendaDigitadaList } from "../../../../routes/coordinator";
import ModalSendEmailRequest from "./modalSendEmailRequest";
import VendasDigitadasApi from "../../../../services/vendasDigitadasApi";
import { useSetRecoilState, useRecoilState } from "recoil";
import { GRAY, GRAY_DARK, GREENMONEDD, VARIANT } from "../../../../constants/colors";

export default function ModalRevisaoPixDireto({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);
  const onClose = () => {
    setIsOpen(false);
  };
  const navigate = useNavigate();
  // console.log("item para venda no modal", item);

  const [openModalSendEmail, setOpenModalSendEmail] = useState(false);
  const [token, setToken] = useState("");

  async function postVendaDigitada() {
    try {
      const response = await VendasDigitadasApi.postVendaDigitada(item);
      setToken(response.token);
      // onClose();
      setOpenModalSendEmail(true);
    } catch (error) {
      console.log("error", error);
      toast.error(`Não foi possível registrar a venda! Erro: ${error}`);
    }
  }

  function SumTotal() {
    if (item.itens.length) {
      const soma = item.itens.length
        ? item.itens
            .map((i: any) => {
              return i.valorItem * i.quantidade;
            })
            .reduce((a: any, b: any) => a + b, 0)
        : 0;
      return soma.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
  }

  // console.log("soma dos itens", SumTotal());

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalBody>
            <TitleFlex item={"Informações do Pagador"} />
            <Flex px={4} flexDir={"column"}>
              <Text fontSize={"14px"} my={2}>
                {item && `Nome : ${item.nomePagador}`}
              </Text>
              <Text fontSize={"14px"} my={2}>
                {item && `E-mail : ${item.emailPagador}`}
              </Text>
            </Flex>
            <TitleFlex item={"Informações de Pagamento"} />
            <Flex px={4} flexDir={"column"}>
              <Text fontSize={"14px"} my={1}>
                {item &&
                  `Pagamento por PIX : ${
                    item.permitirPix === false ? "Não" : "Sim"
                  }`}
              </Text>
              <Text fontSize={"14px"} my={1}>
                {item && `Parcelamento Minimo : ${item.parcelaMinima}`}
              </Text>
              <Text fontSize={"14px"} my={1}>
                {item && `Parcelamento Máximo : ${item.parcelaMaxima}`}
              </Text>
            </Flex>
            <TitleFlex item={"Itens da Venda"} />

            {item && item.itens.length ? (
              item.itens.map((i: any, index: any) => {
                return (
                  <Flex
                    flexDir={"row"}
                    px={6}
                    key={index}
                    my={2}
                    justifyContent={"space-between"}
                  >
                    <Flex flexDir={"column"} w={"80%"}>
                      <Text fontWeight={"bold"}>
                        {i.codigo != ""
                          ? `${i.codigo} - ${i.descricao}`
                          : i.descricao}
                      </Text>
                      <Text>{`Quantidade : ${i.quantidade}`}</Text>
                      <Text>{`Valor do item : ${i.valorItem.toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )}`}</Text>
                    </Flex>
                    <Flex alignItems={"center"}>
                      <Text
                        fontWeight={"bold"}
                        fontSize={"16px"}
                        color={GRAY_DARK}
                      >
                        {(i.quantidade * i.valorItem).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Text>
                    </Flex>
                  </Flex>
                );
              })
            ) : (
              <Flex px={6}>
                <Text color={"red"} fontWeight={"bold"} fontSize={"1.2rem"}>
                  Ainda não foram cadastrados itens para esta venda!
                </Text>
              </Flex>
            )}
            {item && item.itens.length ? (
              <>
                <TitleFlex item={"Total da Venda"} />
                <Flex justifyContent={"flex-end"} pr={6}>
                  <Text fontWeight={"bold"} fontSize={"18px"} color={VARIANT}>
                    {item.itens.length ? SumTotal() : "R$ 0,00"}
                  </Text>
                </Flex>
              </>
            ) : (
              <></>
            )}

            <TitleFlex item={"Mensagem"} />
            <Flex px={4}>
              <Text fontSize={"14px"}>
                {item.mensagem
                  ? item.mensagem
                  : `Não há mensagens para esta venda!`}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              background={GREENMONEDD}
              color={"white"}
              mr={3}
              isDisabled={
                item.nomePagador != "" &&
                item.emailPagador != "" &&
                item.itens.length > 0 &&
                item.idCliente > 0
                  ? false
                  : true
              }
              onClick={() => {
                postVendaDigitada();
              }}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
        <ModalSendEmailRequest
          isOpen={openModalSendEmail}
          setIsOpen={setOpenModalSendEmail}
          token={token}
        />
      </Modal>
    </>
  );
}
